import { FONT_BASE } from '../themeConstants'

export const muiComponentsMiscSurfaces = {
  MuiTab: {
    styleOverrides: {
      root: {
        fontSize: FONT_BASE,
        textTransform: 'none',
      },
    },
  },
  MuiAlert: {
    styleOverrides: {
      message: {
        fontSize: FONT_BASE,
      },
    },
  },
  MuiTableCell: {
    styleOverrides: {
      root: ({ theme }) => ({
        fontSize: FONT_BASE,
        color: theme.palette.text.primary,
        borderBottomColor: theme.palette.divider,
      }),
      head: ({ theme }) => ({
        color: theme.palette.text.secondary,
        backgroundColor: theme.palette.action.selected,
      }),
    },
  },
}
